module.exports = __webpack_public_path__ + "assets/0eb41a8e5c9f8a1d68acaf39bb8c75a6.mp3";